"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\ttransition: width 0.2s linear;\n\theight: 100%;\n\tbackground: ", ";\n\twidth: ", "%;\n\tborder-radius: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\twidth: 100%;\n\theight: ", "px;\n\tbackground: ", ";\n\tborder-radius: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\ttext-align: center;\n\tline-height: ", "px;\n\tcolor: #fff;\n\tfont-size: 14px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Percent = _styledComponents.default.div(_templateObject(), function (props) {
  return props.height;
});

Percent.displayName = 'Percent';

var Bar = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.height;
}, function (props) {
  return props.color;
}, _vars.default.borderRadius);

Bar.displayName = 'Bar';

var BarInner = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.color;
}, function (props) {
  return props.progress;
}, _vars.default.borderRadius);

BarInner.displayName = 'BarInner';

var ProgressBar = function ProgressBar(_ref) {
  var percentage = _ref.percentage,
      barColor = _ref.barColor,
      backgroundColor = _ref.backgroundColor,
      showPercentage = _ref.showPercentage,
      className = _ref.className,
      height = _ref.height,
      rest = _objectWithoutPropertiesLoose(_ref, ["percentage", "barColor", "backgroundColor", "showPercentage", "className", "height"]);

  return _react.default.createElement(Bar, _extends({
    className: className,
    color: backgroundColor,
    height: height
  }, rest), _react.default.createElement(BarInner, {
    color: barColor,
    progress: percentage
  }), showPercentage && _react.default.createElement(Percent, {
    height: height
  }, percentage, "%"));
};

ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = {
  percentage: _propTypes.number.isRequired,
  barColor: _propTypes.string,
  backgroundColor: _propTypes.string,
  showPercentage: _propTypes.bool,
  className: _propTypes.string,
  height: _propTypes.number
};
ProgressBar.defaultProps = {
  barColor: _colors.default.secondary,
  backgroundColor: _colors.default.secondaryLight,
  showPercentage: true,
  className: '',
  height: 24
};
var _default = ProgressBar;
exports.default = _default;